export default function (value) {
  return parseInt(value) + 1;
}
